import { getDayEnd } from './getDayEnd';

const dateIsYesterday = (timestamp = '', showYesterday?: boolean) => {
  if (!showYesterday) false;

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const dateIsEnd = getDayEnd(new Date(timestamp).toISOString());
  const dateYesterdayEnd = getDayEnd(yesterday.toISOString());

  return dateIsEnd === dateYesterdayEnd;
};

export const dateTimeShort = (
  timestamp = new Date().toISOString(),
  options?: {
    showYesterday?: boolean;
    t?: (key: string) => string;
    includeYear?: boolean;
  }
) => {
  const [monthDay, year, time] = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: '2-digit',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })
    .format(new Date(timestamp))
    ?.split(',');

  const [month, day] = monthDay?.split(' ');

  const dateWrittenConsideringYear = options?.includeYear
    ? `${day} ${month} ${year}`
    : `${day} ${month}`;

  const dateWritten = dateIsYesterday(timestamp, options?.showYesterday)
    ? options?.t?.('utils.yesterday')
    : dateWrittenConsideringYear;

  return `${dateWritten}, ${time}`;
};
